"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EventEnvelopeBaseSchema = exports.MonetaryValueSchema = exports.MonetaryAmountSchema = exports.CurrencySchema = void 0;
exports.defineEvent = defineEvent;
const zod_1 = require("zod");
const money_1 = require("@vendepay/money");
exports.CurrencySchema = zod_1.z.enum(money_1.CURRENCIES);
exports.MonetaryAmountSchema = zod_1.z.string().regex(/^-?\d+(\.\d{1,3})?$/);
exports.MonetaryValueSchema = zod_1.z
    .object({
    amount: exports.MonetaryAmountSchema,
    currency: exports.CurrencySchema,
})
    .strict();
exports.EventEnvelopeBaseSchema = zod_1.z
    .object({
    id: zod_1.z.string().min(1),
    occurredAt: zod_1.z.string().datetime({ offset: true }),
    producer: zod_1.z.string().min(1),
    correlationId: zod_1.z.string().min(1),
    causationId: zod_1.z.string().min(1).optional(),
})
    .strict();
function defineEvent(definition) {
    const schema = exports.EventEnvelopeBaseSchema.extend({
        type: zod_1.z.literal(definition.type),
        version: zod_1.z.literal(definition.version),
        payload: definition.payload,
    }).strict();
    return {
        ...definition,
        schema,
        parse(input) {
            return schema.parse(input);
        },
    };
}
//# sourceMappingURL=event.js.map